module.exports = __webpack_public_path__ + "static/media/ico_simulation_category_nose.9588ee11.png";